import React from 'react';
// import Datas from '../../data/about-us/mondiya/about-us2.json';
import { Container, Row, Col } from 'react-bootstrap';
import { Styles } from "../styles/mondiya/aboutUsTwo.js";
import { useTranslation } from 'react-i18next';
// import LanguageSelector from './LanguageSelector';

const AboutUsTwo = () => {
    const { t } = useTranslation();
    return (
        <Styles>
            {/* About Us 2 */}
            <section className="about-us2">
                <Container>
                    <Row>
                        <Col md="12">
                            <div className="about-content">
                                <h4 className="about-title">{t('home.aboutUsTwo.secTitle')}</h4>
                                <p className="about-para">{t('home.aboutUsTwo.secDesc1')}</p>
                                <p className="about-para">{t('home.aboutUsTwo.secDesc2')}</p>
                                <p className="about-para">{t('home.aboutUsTwo.secDesc3')}</p>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </Styles>
    )
}

export default AboutUsTwo